
import axios from "axios";
import { BACKEND } from "../constant/constant";

export const webapi = axios.create({
  baseURL: `${BACKEND}/api`,
  headers: {
    "Content-type": "application/json",
  },
});

webapi.interceptors.response.use(response => {
  return response;
}, error => {
 if (!error.response || error.response.status === 401) {
  window.location.href = "/?error=401";
 }
 return Promise.reject(error);
});

export default axios.create({
  baseURL: `${BACKEND}/api`,
  headers: {
    "Content-type": "application/json",
  },
});






export const GetLocalStorageAccessToken = (): string => {
  try {
    let DataString = sessionStorage.getItem("Data")
    if (DataString) {
      let userData = JSON.parse(DataString)
      return userData.result.provider_access_token
    } else {
      return "";
    }
  } catch (error) {
    return "";
  }
};

export const GetLocalStorageData = (): any => {
  try {
    let DataString = sessionStorage.getItem("Data")
    if (DataString) {
      let userData = JSON.parse(DataString)
      return userData.result
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const GetLocalStorageOrganization = (): any => {
  try {
    let DataString = sessionStorage.getItem("organization")
    if (DataString) {
      let userData = JSON.parse(DataString)
      return userData
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};



export const APIEndpointWeb = {
  /**
   * @public
   */

  Login: "/v1/provider/token",
  /**
   * @method post
   */
  GetTableList: "/v1/dsa-nda/all-document",
  // GetTableList: "/v1/dsa/verifiable-credential/all-document",
  /**
   * @method get
   */


  PostGetListfilesPDF: "/v5/verifiable-credential/dsa-nda/get-attachments",
  // PostGetListfilesPDF: "/v1/dsa/verifiable-credential/get-attachments",
   /**
   * @method post
   */

  PostfilesPDF: "/v5/verifiable-credential/created-files",
  // PostfilesPDF: "/v1/dsa/verifiable-credential/created-files",
  /**
   * @method post
   */

    DeleteFilesPDF: "/v5/verifiable-credential/delete-files",
    // DeleteFilesPDF: "/v1/dsa/verifiable-credential/delete-files",
  /**
   * @method delete
   */
  PostDocumentPreview: "/v4/vaccine-certificate/verifiable-credential/multi-sign-ssl/pdf/vc_document/preview",
  // PostDocumentPreview: "/v1/dsa/verifiable-credential/preview",
  /**
   * @method post
   */

  PostDetailDocumentPreview: "/v5/verifiable-credential/detail-preview-document",
  // PostDetailDocumentPreview: "/v1/dsa/verifiable-credential/detail-preview-document",
  /**
   * @method post
   */

  GetAllProvince: "/v1/dsa-nda/all-province",
  // GetAllProvince: "/v1/dsa/verifiable-credential/all-province",
  /**
   * @method get
   */

  GetAllDistrict: "/v1/dsa-nda/all-district?province_code=",
  // GetAllDistrict: "v1/dsa/verifiable-credential/all-district?province_code=",
  /**
   * @method get
   */
  GetAllTambon: "/v1/dsa-nda/all-tambon?district_code=",
  // GetAllTambon: "v1/dsa/verifiable-credential/all-tambon?district_code=",

  /**
   * @method get
   */
  GetAllDocumentWaiting: "/v5/verifiable-credential/dsa-nda/all-document-waiting",
  // GetAllDocumentWaiting: "/v1/dsa/verifiable-credential/all-document-waiting",
  /**
   * @method post
   */

  PostSharedToken: "/v1/dsa-nda/shared-token",
  /**
   * @method post
   */

  PostSignaturebyProvider: "/v5/verifiable-credential/signature-by-provider",
  // PostSignaturebyProvider: "/v1/dsa/verifiable-credential/signature-by-provider",
  /**
   * @method post
   */

  PostcadDocument: "/v5/verifiable-credential/multi-sign-ssl/pdf/cad/document",
  // PostcadDocument: "/v1/dsa/verifiable-credential/document",
  /**
   * @method post
   */

  PostCreateSignatureImage: "/v5/verifiable-credential/create-signature-image",
  /**
   * @method post
   */

  PostChangePerson: "/v5/verifiable-credential/dsa-nda/change-person",
  // PostChangePerson: "/v1/dsa/verifiable-credential/change-person",
  /**
   * @method post
   */
  
    /**
  
   */
    GetdetailDocument: "/v1/dsa-nda/detail-document?document_no",
    // GetdetailDocument: "/v1/dsa/verifiable-credential/detail-document?document_no",
    /**
     * @method get
     */
    PostRejectDocument: "/v1/dsa-nda/reject-document",
    //  PostRejectDocument: "v1/dsa/verifiable-credential/reject-document",

    /**
     * @method post
     */
    PostListPphoMember: "/v5/verifiable-credential/dsa-nda/list-ppho-member",
    // PostListPphoMember: "/v1/dsa/verifiable-credential/list-ppho-member",
    /**
     * @method post
     */
    PostGetComment: "/v5/verifiable-credential/dsa-nda/get-comment",
    // PostGetComment: "/v1/dsa/verifiable-credential/get-comment",
    /**
     * @method post
     */
    PostDetailPerson: "/v5/verifiable-credential/dsa-nda/detail-person",
    // PostDetailPerson: "/v1/dsa/verifiable-credential/detail-person",
    /**
     * @method post
     */
    GetWaitingDocument: "/v5/verifiable-credential/dsa-nda/get-waiting-document",
    // GetWaitingDocument: "/v1/dsa/verifiable-credential/get-waiting-document",
    /**
     * @method post
     */
    MultiSignSslPdfCadUpdateDocument: "v5/verifiable-credential/multi-sign-ssl/pdf/cad/update-document",
    // MultiSignSslPdfCadUpdateDocument: "v1/dsa/verifiable-credential/update-document",
    /**
     * @method post
     */
   

    
};
